/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Not_A_ProductInputs */

const cs_integrations_not_a_product = /** @type {(inputs: Integrations_Not_A_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toto není produktová integrace. Sreality, katastr a kalendáře se nastavují jako samostatné karty.`)
};

const en_integrations_not_a_product = /** @type {(inputs: Integrations_Not_A_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is not a product integration. Sreality, cadastre and calendars are set up as dedicated cards.`)
};

/**
* | output |
* | --- |
* | "This is not a product integration. Sreality, cadastre and calendars are set up as dedicated cards." |
*
* @param {Integrations_Not_A_ProductInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_not_a_product = /** @type {((inputs?: Integrations_Not_A_ProductInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Not_A_ProductInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_not_a_product(inputs)
	return cs_integrations_not_a_product(inputs)
});